import React from 'react'
import ContactService from './ContactService'

interface ErrorDisplayProps {
  error: string
  customerServiceUrl?: string
}

const ErrorDisplay: React.FC<ErrorDisplayProps> = ({ error, customerServiceUrl }) => {
  return (
    <div
      style={{
        background: 'rgba(255, 255, 255, 0.9)',
        borderRadius: '16px',
        padding: '24px',
        margin: '16px',
        textAlign: 'center',
        boxShadow: '0 4px 20px rgba(0, 0, 0, 0.1)',
      }}
    >
      <div
        style={{
          fontSize: '48px',
          marginBottom: '12px',
        }}
      >
        ⚠️
      </div>
      <div
        style={{
          color: '#E74C3C',
          fontSize: '16px',
          fontWeight: 600,
          marginBottom: '8px',
        }}
      >
        {error}
      </div>
      <div
        style={{
          color: '#666',
          fontSize: '14px',
          marginBottom: '16px',
        }}
      >
        请稍后重试或联系客服
      </div>
      <ContactService url={customerServiceUrl} size="large" />
    </div>
  )
}

export default ErrorDisplay
